<zest-title-step [mainTitle]="'Complete downpayment'"></zest-title-step>
<div class="card">
  <div class="content">
    <div class="row">
      <p class="text-center heading">
        <span>Your EMI plan has been approved</span>
        <span><img class="check-circle" src="../../../assets/images/check-circle.svg" /></span>
      </p>
      <div class="col s12 m12 l12 center red-text error-msg" *ngIf="errorMsg" [textContent]="errorMsg"></div>
      <div class="col s12 m12 l12">
        <zest-card></zest-card>
        <div class="center-div">
          <div class="row text-center margin-top-1rem margin-bottom--1rem">
            <div class="col s12">
              <div class="zest-row center disclaimer-container">
                <div class="inline-block">
                  <img src="../../../assets/images/shield-V2.png" class="shield-img" />
                </div>
                <div class="inline-block">
                  <div class="disclaimer1">100% refundable</div>
                  <div class="disclaimer2">Risk free, cancel anytime</div>
                </div>
              </div>
            </div>
            <div *ngIf="!application.IsCODOnly" class="col s12 margin-top-1rem">
              <button [ladda]="processingElec" [class]="processingElec?'btn waves-effect zest-btn processing ladda-button elec-button':'btn waves-effect zest-btn ladda-button elec-button'"
                [disabled]="processingElec || processingCOD" (click)="payWithElec()">
                <span>PROCEED TO PAY</span>
                <span class="currency" [textContent]="((application.DownpaymentAmount + application.ProcessingFee) | RupeeCurrencyPipe)"></span>
              </button>
              <p class="disclaimer3">To book this order</p>
            </div>
            <div *ngIf="(application && (application.IsCODEnabled || application.IsCODOnly))" class="col s12" [class.margin-top-1rem]="application.IsCODOnly">
              <ng-container *ngIf="!application.IsCODOnly">
                <div class="clr"></div>
                <div class="center">
                  <hr class="cod">
                </div>
              </ng-container>
              <button [ladda]="processingCOD" [class]="processingCOD?'btn waves-effect zest-btn processing ladda-button':'btn waves-effect zest-btn-3-inverted ladda-button'"
                [disabled]="processingElec || processingCOD" (click)="payWithCOD()">
                <span *ngIf="!payLater">PAY ON DELIVERY</span>
                <span *ngIf="payLater">PAY LATER</span>
              </button>
            </div>
            <div class="clr"></div>
            <div class="center">
              <hr class="trust">
            </div>
            <div class="col s12">
              <div class="center trusted-by">Trusted By</div>
              <img src="../../assets/images/trust-logo.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<form name="payuForm" id="payuForm" *ngIf="payUform" method="POST" [action]="payuActionUrl" enctype="application/x-www-form-urlencoded">
  <input *ngFor="let data of payUform | JsonKeysPipe" type="hidden" [name]="data.key" [value]="data.value" />
</form>
<div id="showDPPopupModal" class="modal" materialize="modal" [materializeParams]="[{dismissible: false}]">
  <div class="modal-content center">
    <h5>Payment processing</h5>
    <p>Your transaction is in progress, please login after some time as it might take upto 30 minutes to process.</p>
  </div>
</div>